import { render, staticRenderFns } from "./application-wizard-card.vue?vue&type=template&id=b0a459a8&"
import script from "./application-wizard-card.vue?vue&type=script&lang=ts&"
export * from "./application-wizard-card.vue?vue&type=script&lang=ts&"
import style0 from "./application-wizard-card.vue?vue&type=style&index=0&id=b0a459a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports